import { Button, Grid } from "@mui/material";
import { ColumnDef } from "@tanstack/react-table";
import { Buffer } from "buffer";
import { saveAs } from "file-saver";
import React, { useMemo } from "react";
import BpDashboardTable from "../../ReactTable/BpDashboardTable";

const PartnerUserBulkUploadErrorReport = (props: any) => {
  const columnDefinitionPartnerUserBulkUploadErrorReport = useMemo(
    (): ColumnDef<any>[] => [
      {
        header: "Partner user name",
        accessorKey: "name",
        size: 200,
      },
      {
        header: "Partner Name",
        accessorKey: "businessPartnerName",
        size: 200,
      },
      {
        header: "Error reason",
        accessorKey: "reason",
        size: 300,
      },
      {
        header: "Mail ID",
        accessorKey: "emailId",
        size: 240,
      },
      {
        header: "Designation",
        accessorKey: "designation",
        size: 180,
      },

      {
        header: "Balance Confirmation & Ledger Request",
        accessorKey: "balanceConfirmation",
        size: 240,
      },
      {
        header: "MSME Confirmation",
        accessorKey: "msmeConfirmation",
        size: 140,
      },
    ],

    []
  );

  const downloadPartnerUsersErrorReport = () => {
    const excelData = Buffer.from(props.errorListsPartnerUsersBase64, "base64");
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const blob = new Blob([excelData], { type: fileType });
    saveAs(blob, "Partner User Record error report.xlsx");
  };

  return (
    <>
      <header className="modal-card-head">
        <p className="modal-card-title">Record error report</p>
        <button
          className="delete"
          aria-label="close"
          onClick={() => props.setOpenPartnerUserBulkUploadErrorReport(false)}
        />
      </header>
      <section className="modal-card-body">
        <Grid>
          <p className="p_20 fw_600">
            {props.numberOfUsersSaved} records successfully added, {props.numberOfUsersFailed} records ignored due to
            errors mentioned below. Kindly check and re-upload
          </p>
        </Grid>
        <Grid>
          <BpDashboardTable
            columns={columnDefinitionPartnerUserBulkUploadErrorReport}
            rows={props.rowsDataPartnerUserBulkUploadErrorReport}
            sortEnable={true}
          />
        </Grid>
      </section>
      <footer className="modal-card-foot space_between">
        <div>
          <Button
            className="theme_btn"
            onClick={() => {
              downloadPartnerUsersErrorReport();
            }}
          >
            Download excel
          </Button>
        </div>
        <div>
          <Button
            className="theme_btn"
            onClick={() => {
              props.setOpenPartnerUserBulkUploadErrorReport(false);
            }}
          >
            Close
          </Button>
        </div>
      </footer>
    </>
  );
};

export default PartnerUserBulkUploadErrorReport;
